import React, { useEffect, useRef, useState } from "react";

const FAQS = [
  {
    icon: (
      // Truck icon
      <svg width="24" height="24" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h3.17a2 2 0 0 1 1.66.89l2.58 3.87A2 2 0 0 1 23 14.13V16a2 2 0 0 1-2 2h-1"/><circle cx="5.5" cy="18.5" r="1.5"/><circle cx="18.5" cy="18.5" r="1.5"/></svg>
    ),
    title: "Shipping Policy",
    data: "We ensure safe, 6-8 working days delivery with trusted couriers. We provide free shipping on orders above ₹500 (within India)."
  },
  {
    icon: (
      // INR (Rupee) icon
      <svg width="24" height="24" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><text x="4" y="19" fontSize="18" fontFamily="Arial" fill="#C21833">₹</text></svg>
    ),
    title: "Payment Policy",
    data: "We accept payments via UPI and net banking. Cash on Delivery is not available."
  },
  {
    icon: (
      // Refresh/Return icon
      <svg width="24" height="24" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
    ),
    title: "Return & Refund Policy",
    data: "Cherry On Top adheres to a strict NO RETURN and REFUND policy."
  }
];

const styles = {
  container: {
    width: "100%",
    maxWidth: 420,
    margin: "0 auto",
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(201,161,74,0.07)",
    padding: "24px 18px 32px 18px",
    boxSizing: "border-box",
    position: "relative",
    overflow: "hidden"
  },
  slide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 140,
    transition: "opacity 0.4s"
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 0
  },
  icon: { marginRight: 8, display: "flex", alignItems: "center" },
  title: { fontSize: 18, fontWeight: 600, color: "#C21833", margin: 0, maxWidth: "100%", overflowWrap: "anywhere" },
  data: { fontSize: 15, color: "#4a5568", margin: "10px 0 0 0", textAlign: "center", maxWidth: "100%", overflowWrap: "anywhere" },
  dots: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: 18
  },
  dot: (active) => ({
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: active ? "#C21833" : "#e0e0e0",
    transition: "background 0.2s",
    cursor: "pointer"
  })
};

export default function FAQSlider() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % FAQS.length);
    }, 3500);
    return () => clearTimeout(timeoutRef.current);
  }, [index]);

  return (
    <div style={styles.container}>
      <div style={styles.slide}>
        <div style={styles.titleRow}>
          <span style={styles.icon}>{FAQS[index].icon}</span>
          <h3 style={styles.title}>{FAQS[index].title}</h3>
        </div>
        <div style={styles.data}>{FAQS[index].data}</div>
      </div>
      <div style={styles.dots}>
        {FAQS.map((_, i) => (
          <div
            key={i}
            style={styles.dot(i === index)}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
}
